import React from 'react'
import { MultiLevel, SingleLevel } from '.'
import { hasChildren } from './utils'

interface MenuItemProps {
  item: any
  countrySelection?: string
}

export const MenuItem: React.FC<MenuItemProps> = ({
  item,
  countrySelection,
}) => {
  const Component = hasChildren(item) ? MultiLevel : SingleLevel
  return <Component {...item} countrySelection={countrySelection} />
}

MenuItem.displayName = 'MenuItem'
